


const baseGeneralUrl = "General"
  const endpoints = {
   getCompanies:`${baseGeneralUrl}/GetFromWhoOptions`,
  };
  
  export default endpoints;
  



